const status = {
  userStatus: {
    active: 'active',
    unverified: 'unverified',
    locked: 'locked',
    disabled: 'disabled',
    softDeleted: 'soft_deleted'
  },

  offerRequestStatus: {
    pending: 'pending',
    accepted: 'accepted',
    cancelled: 'cancelled',
    cancelled_by_admin: 'cancelled_by_admin'
  },

  itemRequestStatus: {
    pendingAcceptanceByTraveler: 'pending_acceptance_by_traveler',
    acceptedByTraveler: 'accepted_by_traveler',
    deniedByTraveler: 'denied_by_traveler',
    cancelledByShopper: 'cancelled_by_shopper',
    reassignedByShopper: 'reassigned_by_shopper',

    // Purchase Readiness Statuses
    readyForPurchase: 'ready_for_purchase',
    notReadyInsufficientTime: 'not_ready_insufficient_time',
    notReadyMissingBooking: 'not_ready_missing_booking',
    notReadyMissingExternalFlightBookingDetails: 'not_ready_missing_external_flight_booking_details',
    pendingReadinessCheck: 'pending_readiness_check',
    purchaseReadinessExpired: 'purchase_readiness_expired'
  },

  deliveryStatus: {
    purchasedByTraveler: 'purchased_by_traveler',
    purchasedByAdmin: 'purchased_by_admin',
    purchasedByAgentAdmin: 'purchased_by_agent_admin',
    inTransitToTraveler: 'in_transit_to_traveler',
    deliveredToTravelerAddress: 'delivered_to_traveler_address',
    confirmedReceivedByTraveler: 'confirmed_received_by_traveler',
    readyForDropoffAtLocker: 'ready_for_dropoff_at_locker',
    awaitingShopperPickupFromLocker: 'awaiting_shopper_pickup_from_locker',
    confirmedDeliveredToShopperViaLocker: 'confirmed_delivered_to_shopper_via_locker',
    lockerDeliveryCancelled: 'locker_delivery_cancelled',
    confirmedInDestinationCountry: 'confirmed_in_destination_country',
    confirmedDeliveredToShopperByTraveler: 'confirmed_delivered_to_shopper_by_traveler',
    confirmedDeliveredToShopperByShopper: 'confirmed_delivered_to_shopper_by_shopper',
    confirmedDeliveredToTravelerAddressByAdmin: 'confirmed_delivered_to_traveler_address_by_admin',
    confirmedDeliveredToShopperByAdmin: 'confirmed_delivered_to_shopper_by_admin',
    confirmedDeliveredToTravelerAddressByAgentAdmin: 'confirmed_delivered_to_traveler_address_by_agent_admin',
    confirmedDeliveredToShopperByAgentAdmin: 'confirmed_delivered_to_shopper_by_agent_admin',
    lost: 'lost',
    outOfStock: 'out_of_stock'
  },

  flightStatus: {
    interestedInFlight: 'interested_in_flight',
    noLongerInterestedInFlight: 'no_longer_interested_in_flight',
    flightBooked: 'flight_booked',
    flightBookingCancelledBeforePayment: 'flight_booking_cancelled_before_payment',
    flightPaid: 'flight_paid',
    flightCancelledAfterPayment: 'flight_cancelled_after_payment',
    flightRefunded: 'flight_refunded',
    flightCompleted: 'flight_completed'
  },

  externalFlightBookingStatus: {
    externalFlightBookingRequestCreated: 'external_flight_booking_request_created',
    externalFlightBookingRequestProcessing: 'external_flight_booking_request_processing',
    externalFlightBookingRequestDenied: 'external_flight_booking_request_denied',
    externalFlightBookingRequestCancelled: 'external_flight_booking_request_cancelled',
    itineraryCreatedForExternalFlightBooking: 'itinerary_created_for_external_flight_booking',
    externalFlightBookingDetailsConfirmed: 'external_flight_booking_details_confirmed'
  },

  paymentStatus: {
    // Payment Statuses
    paymentHoldCreated: 'payment_hold_created',
    paymentHoldProcessing: 'payment_hold_processing',
    paymentHoldConfirmed: 'payment_hold_confirmed',
    paymentHoldFailed: 'payment_hold_failed',
    paymentHoldCancelled: 'payment_hold_cancelled',

    paymentHoldReleaseFailed: 'payment_hold_release_failed',

    paymentCreated: 'payment_created',
    paymentProcessing: 'payment_processing',
    paymentConfirmed: 'payment_confirmed',
    paymentFailed: 'payment_failed',
    paymentCancelled: 'payment_cancelled',

    // Refund Statuses
    refundCreated: 'refund_created',
    refundProcessing: 'refund_processing',
    refundConfirmed: 'refund_confirmed',
    refundFailed: 'refund_failed',
    refundCancelled: 'refund_cancelled'
  },

  transferStatus: {
    transferCreated: 'transfer_created',
    transferProcessing: 'transfer_processing',
    transferConfirmed: 'transfer_confirmed',
    transferFailed: 'transfer_failed',
    transferCancelled: 'transfer_cancelled'
  },

  discountCodeStatus: {
    discountCodeActive: 'discount_code_active',
    discountCodeExpired: 'discount_code_expired',
    discountCodeUsageLimitReached: 'discount_code_usage_limit_reached',
    discountCodeCancelled: 'discount_code_cancelled',
    discountCodeInvalid: 'discount_code_invalid',
    discountCodeUsed: 'discount_code_used'
  },

  fulfillmentOrderStatus: {
    pendingWarehouseReceipt: 'pending_warehouse_receipt',
    warehouseReceived: 'warehouse_received',
    readyForTravelerPickup: 'ready_for_traveler_pickup',
    withTraveler: 'with_traveler',
    inTransit: 'in_transit',
    processingAtAirport: 'customs_clearance',
    outForDelivery: 'out_for_delivery',
    fulfillmentOrderDelivered: 'fulfillment_order_delivered',
    fulfillmentOrderCancelled: 'fulfillment_order_cancelled',
    refundRequested: 'refund_requested'
  }
}

const statusColors = {
  userStatus: {
    active: 'success',
    unverified: 'warning',
    locked: 'error',
    disabled: 'error',
    softDeleted: 'error'
  },

  offerRequestStatus: {
    pending: 'warning',
    accepted: 'success',
    cancelled: 'error',
    cancelled_by_admin: 'error'
  },

  itemRequestStatus: {
    pendingAcceptanceByTraveler: 'warning',
    acceptedByTraveler: 'success',
    deniedByTraveler: 'error',
    cancelledByShopper: 'error',
    reassignedByShopper: 'warning'
  },

  deliveryStatus: {
    purchasedByTraveler: 'success',
    purchasedByAdmin: 'success',
    purchasedByAgentAdmin: 'success',
    inTransitToTraveler: 'warning',
    deliveredToTravelerAddress: 'success',
    confirmedReceivedByTraveler: 'success',
    readyForDropoffAtLocker: 'warning',
    confirmedInDestinationCountry: 'success',
    confirmedDeliveredToShopperByTraveler: 'success',
    confirmedDeliveredToShopperByShopper: 'success',
    confirmedDeliveredToTravelerAddressByAdmin: 'success',
    confirmedDeliveredToShopperByAdmin: 'success',
    confirmedDeliveredToTravelerAddressByAgentAdmin: 'success',
    confirmedDeliveredToShopperByAgentAdmin: 'success',
    lost: 'error',
    outOfStock: 'error'
  },

  flightStatus: {
    interestedInFlight: 'warning',
    noLongerInterestedInFlight: 'error',
    flightBooked: 'success',
    flightBookingCancelledBeforePayment: 'error',
    flightPaid: 'success',
    flightCancelledAfterPayment: 'error',
    flightRefunded: 'success',
    flightCompleted: 'success'
  },

  paymentStatus: {
    paymentHoldCreated: 'warning',
    paymentHoldProcessing: 'warning',
    paymentHoldConfirmed: 'success',
    paymentHoldFailed: 'error',
    paymentHoldCancelled: 'error',
    paymentHoldReleaseFailed: 'error',
    paymentCreated: 'warning',
    paymentProcessing: 'warning',
    paymentConfirmed: 'success',
    paymentFailed: 'error',
    paymentCancelled: 'error'
  },

  transferStatus: {
    transferCreated: 'warning',
    transferProcessing: 'warning',
    transferConfirmed: 'success',
    transferFailed: 'error',
    transferCancelled: 'error'
  },

  externalFlightBookingStatus: {
    externalFlightBookingRequestCreated: 'warning',
    externalFlightBookingRequestProcessing: 'warning',
    externalFlightBookingRequestDenied: 'error',
    externalFlightBookingRequestCancelled: 'error',
    itineraryCreatedForExternalFlightBooking: 'success',
    externalFlightBookingDetailsConfirmed: 'success'
  },

  discountCodeStatus: {
    discountCodeActive: 'success',
    discountCodeExpired: 'error',
    discountCodeUsageLimitReached: 'warning',
    discountCodeCancelled: 'error',
    discountCodeInvalid: 'error',
    discountCodeUsed: 'info'
  },

  fulfillmentOrderStatus: {
    pendingWarehouseReceipt: 'warning',
    warehouseReceived: 'info',
    readyForTravelerPickup: 'info',
    withTraveler: 'primary',
    inTransit: 'primary',
    processingAtAirport: 'info',
    outForDelivery: 'primary',
    fulfillmentOrderDelivered: 'success',
    fulfillmentOrderCancelled: 'error',
    refundRequested: 'error'
  }
}

export { statusColors }

export default status
